import { authenticationService } from '../../_api/ApiClient';
import store, { logout } from '../../_reducers/store';
import Storage from '../Storage';

export default function userLogout() {
  authenticationService.logout();
  Storage.removeAll();
  store.dispatch(logout());
}
